import ShareableLinkNavigation from './ShareableLinkNavigation.component';

export default ShareableLinkNavigation;
